import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import confetti from "canvas-confetti";

import axios from "axios";
import './OrderSuccess.css'
import { BASE_URL } from "../../config/config";

const OrderSuccess = () => {
  const [purchaseDetails, setPurchaseDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const authToken = sessionStorage.getItem("token");

  const urlParams = new URLSearchParams(window.location.search);
  const order_id = urlParams.get("order_id");

  useEffect(() => {
    const fetchPurchaseDetails = async () => {
      if (!order_id) {
        setError("Order ID is missing in the URL!");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          `${BASE_URL}/getPurchaseDetails`,
          { order_id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setPurchaseDetails(response.data.purchase_History);
      } catch (err) {
        setError("Failed to fetch order details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchPurchaseDetails();
  }, [order_id, authToken]);

  const status = purchaseDetails?.transaction_status?.toUpperCase();

  useEffect(() => {
    if (status === "SUCCESS") {
      // confetti({
      //   particleCount: 150,
      //   spread: 70,
      //   origin: { y: 0.6 },
      // });
    }
  }, [status]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <h4>Loading your order details...</h4>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5 text-danger">
        <h4>{error}</h4>
        <Link to="/courses" className="btn main-btn mt-3">
          Browse Courses
        </Link>
      </div>
    );
  }

  const billing = purchaseDetails?.billing_details;

  // Customize message and icon based on transaction status
  let title = "Thank You For Your Purchase";
  let message = "Enrollment Successful! Your Clavix course is now available.";
  let statusClass = "text-success";
  let icon = "✓";
  let iconBgClass = "bg-success";

  if (status === "FAILED") {
    title = "Payment Failed";
    message = "Unfortunately, your payment was not successful. Please try again.";
    statusClass = "text-danger";
    icon = "✕";
    iconBgClass = "bg-danger";
  } else if (status === "PENDING") {
    title = "Payment Pending";
    message = "Your payment is currently being processed. You will be notified once it's confirmed.";
    statusClass = "text-warning";
    icon = "⚠";
    iconBgClass = "bg-warning text-dark";
  }

  return (
    <div className="order-success-wrapper container-fluid">
      <div className="order-success-card container text-center">
        <div className="checkmark-wrapper">
          <div className={`checkmark ${iconBgClass}`}>{icon}</div>
        </div>
        <h1 className={`order-title ${statusClass}`}>{title}</h1>
        <p className="order-message">{message}</p>

        <div className="order-success-summary d-flex justify-content-center">
          <ul className="order-summary-list text-start">
            <h2 className="order-summary-heading">Order Summary</h2>
            <li><strong>Order ID:</strong> {purchaseDetails.order_id}</li>
            <li><strong>Purchase Date:</strong> {new Date(purchaseDetails.purchase_date).toLocaleString()}</li>
            <li><strong>Transaction Status:</strong> {status || "Pending"}</li>

            {billing && (
              <>
                <li><strong>Name:</strong> {billing.FirstName} {billing.lastName}</li>
                <li><strong>Email:</strong> {billing.email}</li>
                <li><strong>Phone:</strong> {billing.phoneNumber}</li>
                <li><strong>Address:</strong> {billing.Address}, {billing.city}, {billing.state}, {billing.country} - {billing.postcode}</li>
              </>
            )}
          </ul>
        </div>

        <Link to="/courses" className="btn main-btn mt-4">
          Browse More Courses
        </Link>
      </div>
    </div>
  );
};

export default OrderSuccess;
